import {
  createStore,
  applyMiddleware,
  compose,
} from 'redux';
import createSagaMiddleware, {
  END,
} from 'redux-saga';
// import logger from 'redux-logger';

import analyticMiddleware from './middleware/analyticMiddleware';
import rootReducer from '../reducers';

// eslint-disable-next-line
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();

const middleware = [
  analyticMiddleware,
  sagaMiddleware,
  // logger,
].filter(Boolean);

function configureStore(initialState: any) {
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(
      applyMiddleware(...middleware),
    ),
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      // eslint-disable-next-line
      store.replaceReducer(require('../reducers').default);
    });
  }

  store.runSaga = sagaMiddleware.run;
  store.close = () => store.dispatch(END);
  return store;
}

export default configureStore;
